import Vue from 'vue'
import Router from 'vue-router'
import MainView from "../views/MainView";
import AdminView from "../views/AdminView";
import MyCampaignView from "../views/MyCampaignView";
import PaymentSuccessView from "../views/PaymentSuccessView";
import OrganizationCampaignView from "../views/OrganizationCampaignView";
import OrganizationCampaignsView from "../views/OrganizationCampaignsView";
import TeamsView from "../views/TeamsView";
import TeamInfoView from "../views/TeamInfoView";
import SearchView from "../views/SearchView";
import SubscriptionSuccessView from "../views/SubscriptionSuccessView";
import MyDonationsView from "../views/MyDonationsView";
import UserInfoView from "../views/UserInfoView"
import CampaignInfoView from '../views/CampaignInfoView'
import UserCampaignView from "../views/UserCampaignView";
import ResetPassword from "../components/user/ResetPassword";
import store from "../modules/store";
import PrivacyPolicyView from "../views/PrivacyPolicyView";
import InfoView from "@/views/InfoView";
import CategoryOrganizationsView from "../views/CategoryOrganizationsView";
import TeamsListView from "../views/TeamsListView";
import CategoriesListView from "@/views/CategoriesListView";
import OrganizationsListView from "@/views/OrganizationsListView";
import FaqView from "@/views/FaqView";
import FundRasisingInfoView from "@/views/FundRaisingInfoView";

Vue.use(Router)

const router = new Router( {
    routes: [
        {
            path: '/',
            name: 'main-view',
            component: MainView
        },
        {
            path: '/index.html',
            name: 'index',
            component: MainView
        },
        {
            path: '/adminview',
            name: 'admin-view',
            component: AdminView,
            meta: {requiresAdminAuth: true}
        },
        /*{
            path: '/campaigns',
            name: 'campaigns-view',
            component: CampaignsView,
            meta: {requiresUserAuth: true}
        },*/
        {
            path: '/mycampaigns',
            name: 'my-campaign-view',
            component: MyCampaignView,
            meta: {requiresUserAuth: true}
        },
        {
            path: '/user/:id/campaigns',
            name: 'user-campaign-view',
            component: UserCampaignView,
            props: true
        },
        {
            path: '/organizationcampaigns',
            name: 'organization-campaign-view',
            component: OrganizationCampaignView,
            meta: {requiresSuperUserAuth: true}
        },
        {
            path: '/teams',
            name: 'teams-view',
            component: TeamsView,
            meta: {requiresSuperUserAuth: true}
        },
        {
            path: '/teamslist',
            name: 'teams-list-view',
            component: TeamsListView
        },
        {
            path: '/categorieslist',
            name: 'categories-list-view',
            component: CategoriesListView
        },
        {
            path: '/organizationslist',
            name: 'organizations-list-view',
            component: OrganizationsListView
        },
        {
            path: '/paymentsuccess',
            name: 'payment-success-view',
            component: PaymentSuccessView,
            props: true
        },
        {
            path: '/subscriptionsuccess',
            name: 'subscription-success-view',
            component: SubscriptionSuccessView,
            props: true
        },
        {
            path: '/team/:id',
            name: 'team-info-view',
            component: TeamInfoView,
            props: true
        },
        {
            path: '/campaign/:id',
            name: 'campaign-info-view',
            component: CampaignInfoView,
            props: true
        },
        {
            path: '/organization/:id',
            name: 'organization-campaigns-view',
            component: OrganizationCampaignsView,
            props: true
        },
        {
            path: '/category/:id',
            name: 'category-organizations-view',
            component: CategoryOrganizationsView,
            props: true
        },
        {
            path: '/search',
            name: 'search-view',
            component: SearchView
        },
        {
            path: '/mydonations',
            name: 'my-donations-view',
            component: MyDonationsView,
            meta: {requiresUserAuth: true}
        },
        {
            path: '/myinfo',
            name: 'user-info-view',
            component: UserInfoView,
            meta: {requiresUserAuth: true}
        },
        {
            path: '/privacy',
            name: 'privacy-policy-view',
            component: PrivacyPolicyView,
        },
        {
            path: process.env.VUE_APP_PSW_RESET_LINK,
            name: 'reset-password',
            component: ResetPassword
        },
        {
            path: '/info',
            name: 'info-view',
            component: InfoView,
        },
        {
            path: '/faq',
            name: 'faq-view',
            component: FaqView,
        },
        {
            path: '/fundraising',
            name: 'fund-raising-info-view',
            component: FundRasisingInfoView,
        },
    ],
    mode: 'history'
});

// eslint-disable-next-line no-unused-vars
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresUserAuth)) {
        if (!store.state.token || store.state.user.admin) {
            next({name: 'main-view'})
        } else {
            next()
        }
    } else if (to.matched.some(record => record.meta.requiresSuperUserAuth)) {
        if (!store.state.token || !store.state.user.organization || store.state.user.admin) {
            next({name: 'main-view'})
        } else {
            next()
        }
    } else if (to.matched.some(record => record.meta.requiresAdminAuth)) {
        if (!store.state.token || !store.state.user.admin) {
            next({name: 'main-view'})
        } else {
            next()
        }
    } else {
        next()
    }
})

export default router;
